<template>
  <v-application v-if="user.is_boss === true || access.setting_organization">
    <v-settings :loading_data="organ_dialog">
      <v-toolbar flat>
        <v-toolbar-title>{{ $t("organizations") }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-text-field
        class="pl-5 pr-5"
        :label="$t('organization_name')"
        v-model="organization.name"
      />
      <v-text-field
        class="pl-5 pr-5"
        :label="$t('inn')"
        v-model="organization.inn"
      />
      <!-- <v-select
        class="pl-5 pr-5"
        :label="$t('payments')"
        :items="organization.payments"
        multiple
        outlined
        dense
      >
      </v-select> -->
      <v-text-field
        class="pl-5 pr-5"
        :label="$t('address')"
        v-model="organization.address"
      />
      <v-text-field
        class="pl-5 pr-5"
        :label="$t('loyalty_bonus')"
        v-model="organization.loyalty_bonus"
      />
      <v-text-field
        class="pl-5 pr-5"
        :label="$t('epos_token')"
        v-model="organization.epos_token"
      />
      <v-text-field
        class="pl-5 pr-5"
        :label="$t('director_name')"
        v-model="organization.director_name"
      />
      <v-text-field
        class="pl-5 pr-5"
        :label="$t('accaunter')"
        v-model="organization.accaunter"
      />
      <v-text-field
        class="pl-5 pr-5"
        v-mask="mask"
        :label="$t('org_phone_number')"
        v-model="organization.org_phone_number"
      />
      <v-text-field
        class="pl-5 pr-5"
        :label="$t('taxes_pair_code')"
        v-model="organization.taxes_pair_code"
      />
      <v-flex md11>
        <v-list-item class="ma-0 pl-5 pr-5">
          <v-list-item-content
            class="noselect"
            @click="organization.is_ofd = !organization.is_ofd"
          >
            <v-list-item-title>{{ $t("mxik") }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-switch v-model="organization.is_ofd" />
          </v-list-item-action>
        </v-list-item>
      </v-flex>
      <v-flex md11>
        <v-list-item class="ma-0 pl-5 pr-5">
          <v-list-item-content
            class="noselect"
            @click="organization.is_ofd = !organization.is_ofd"
          >
            <v-list-item-title>{{
              $t("is_same_service_price")
            }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-switch v-model="organization.is_same_service_price" />
          </v-list-item-action>
        </v-list-item>
      </v-flex>
      <template #actions>
        <!-- <v-btn text>
          {{ $t("cancel") }}
        </v-btn> -->
        <v-btn
          text
          color="primary"
          @click="updateOrganization"
          :loading="update_loading"
        >
          {{ $t("update") }}
        </v-btn>
      </template>
    </v-settings>
  </v-application>
</template>
<script>
import Userable from "../../mixins/userable";
import Organization from "../../mixins/organization";
export default {
  mixins: [Userable, Organization],
  data: () => ({
    organization: {
      name: "",
      address: "",
      loyalty_bonus: 0,
      epos_token: "",
      inn: "",
      payments: [],
      taxes_pair_code: "",
      org_phone_number: "",
      accaunter: "",
      director_name: "",
    },
    mask: "+### (##) ### ## ##",
    access: "",
    organ_dialog: false,
    update_loading: false,
  }),
  computed: {
    payment() {
      return [
        {
          text: this.$t("cash"),
        },
        {
          text: this.$t("card"),
        },
        {
          text: this.$t("gift"),
        },
        {
          text: this.$t("debt"),
        },
        {
          text: this.$t("qr_code"),
        },
        {
          text: this.$t("nfc"),
        },
      ];
    },
    form() {
      return {
        name: this.organization.name,
        address: this.organization.address,
        loyalty_bonus: this.organization.address,
        epos_token: this.organization.epos_token,
        inn: this.organization.inn,
        payments: this.organization.payments,
      };
    },
  },
  methods: {
    async resetForm() {
      Object.keys(this.form).forEach((f) => {
        if (this.$refs[f]) {
          this.$refs[f].reset();
        }
      });
    },
    async updateOrganization() {
      this.update_loading = true;
      await this.$communicator("organizations_update", {
        params: this.organization,
      });
      this.$toast.success("Success", { timeout: 2000 });
      this.resetForm();
      this.update_loading = false;
      this.organizationGet();
    },
    async loadOrg() {
      const organization = await this.organizationGet();
      if (!organization) {
        return;
      }
      this.organization = organization;
    },
  },
  watch: {
    organ_dialog() {
      if (!this.organ_dialog) {
        this.organizationGet();
        this.organ_dialog = false;
      }
    },
  },
  async mounted() {
    this.resetForm();
    setTimeout(() => {
      this.loadOrg();
    });
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>